import { ReactNode } from "react";

interface BenefitBlockProps {
  title: string;
  description: string;
  image: string;
  imageAlt: string;
  reverse?: boolean;
  highlight?: string;
  children?: ReactNode;
}

const BenefitBlock = ({
  title,
  description,
  image,
  imageAlt,
  reverse = false,
  highlight,
  children,
}: BenefitBlockProps) => {
  return (
    <section className="py-16 md:py-24">
      <div className="container mx-auto px-6">
        <div
          className={`flex flex-col ${
            reverse ? "lg:flex-row-reverse" : "lg:flex-row"
          } items-center gap-12 lg:gap-20`}
        >
          {/* Image */}
          <div className="w-full lg:w-1/2 animate-fade-in">
            <div className="relative">
              <div className="absolute -inset-4 bg-gradient-to-br from-primary/10 to-accent/10 rounded-3xl blur-2xl opacity-60" />
              <img
                src={image}
                alt={imageAlt}
                className="relative w-full rounded-2xl shadow-xl object-cover aspect-[4/3]"
              />
            </div>
          </div>

          {/* Content */}
          <div className="w-full lg:w-1/2 space-y-6 animate-fade-in">
            {highlight && (
              <span className="inline-block text-sm font-semibold text-primary bg-primary/10 px-4 py-1.5 rounded-full">
                {highlight}
              </span>
            )}
            <h2 className="text-3xl md:text-4xl font-bold text-foreground leading-tight">
              {title}
            </h2>
            <p className="text-lg text-muted-foreground leading-relaxed">
              {description}
            </p>
            {children}
          </div>
        </div>
      </div>
    </section>
  );
};

export default BenefitBlock;
